import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

const StyledHeader = styled.header`
  background-color: ${theme.colors.primary.graysRed};
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;

  width: 100%;
`;

export type HeaderProps = PropsWithChildren & { className?: string };

export const Header: React.FC<HeaderProps> = ({ className, children }) => {
  return (
    <StyledHeader className={className}>
      <Content>{children}</Content>
    </StyledHeader>
  );
};
